// extracted by mini-css-extract-plugin
export default {"bgImage":"index_bgImage_94prp","wrap":"index_wrap_BiQvB","transColor":"index_transColor_OGFPF"};